// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Array<T> {
    paramValues: (param: string) => object[]
}

// eslint-disable-next-line no-extend-native
Array.prototype.paramValues = function (param: string) {
    return this?.map?.(item => item?.[param] ?? item)
}
